import React from 'react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const USER_IMAGES = {
  logo1: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/6lkl3d57_IMG-20260327-WA0045.jpg',
  logo2: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/s7iezbjt_IMG-20260327-WA0046.jpg',
  banner1: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/vblcbb67_IMG-20260327-WA0047.jpg',
  banner2: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/lgxhbord_IMG-20260327-WA0048.jpg',
  interior: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/lj7ee0fy_IMG-20260327-WA0032.jpg',
  gallery1: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/xuak868u_IMG-20260327-WA0032.jpg',
  gallery2: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/gee3dycj_IMG-20260327-WA0033.jpg',
  gallery3: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/1yfiiwyk_IMG-20260327-WA0034.jpg',
  gallery4: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/szm38asn_IMG-20260327-WA0035.jpg',
  gallery5: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/amf86hgd_IMG-20260327-WA0036.jpg',
  // Ambient osvetlenie Audi A4 B9
  ambient: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/e74zrqm9_IMG-20260327-WA0040.jpg',
  // Hviezdny strop
  starRoof1: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/mckj2hat_IMG-20260327-WA0029.jpg',
  starRoof2: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/w8554kjg_IMG-20260327-WA0030.jpg',
  starRoof3: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/97vf0aqa_IMG-20260327-WA0031.jpg',
  // DRL LED pásky
  drlLed: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/o7mcv9fs_IMG-20260327-WA0005.jpg',
  // Ambient VW + BMW červený
  ambientVW: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/r345v209_IMG-20260327-WA0035.jpg',
  ambientBMW: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/qs88dfkr_IMG-20260327-WA0037.jpg',
  ambientRed: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/hlszecx0_IMG-20260327-WA0036.jpg',
  // Svetlomet pred/po renovácia
  headlightBefore: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/r8ktllpm_IMG-20260327-WA0017.jpg',
  headlightAfter: 'https://customer-assets.emergentagent.com/job_light-brilliance-1/artifacts/443iitsy_IMG-20260327-WA0018.jpg',
};

// Logo Component
export const Logo = ({ className = "" }) => (
  <div className={`flex items-center ${className}`}>
    <span className="text-white font-bold text-2xl tracking-tighter">Jasne</span>
    <span className="text-[#00BFFF] font-bold text-2xl tracking-tighter">Svetla</span>
  </div>
);

export const LogoSmall = ({ className = "" }) => (
  <div className={`flex items-center ${className}`}>
    <span className="text-white font-bold text-xl tracking-tighter">Jasne</span>
    <span className="text-[#00BFFF] font-bold text-xl tracking-tighter">Svetla</span>
  </div>
);
